import React, { useCallback, useEffect, useRef, useState } from 'react';
import './configBackups.scss';
import { useApiBackups } from '../../api/api.backups';
import DataGrid, { Column, LoadPanel, Paging, SearchPanel, Toolbar, Item, Pager } from 'devextreme-react/data-grid';
import Button from 'devextreme-react/button';
import { Tooltip } from 'devextreme-react';
import { newToast } from '../../components';

export default () => {
  const { GetAll, Create } = useApiBackups();
  const gridRef = useRef<DataGrid>(null);
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [isCreating, setIsCreating] = useState(false);

  const fetchData = useCallback(async () => {
    try {
      gridRef.current?.instance?.beginCustomLoading('Cargando backups...');
      const backups = await GetAll();
      setDataSource(Array.isArray(backups) ? backups : []);
    } catch (err) {
      console.error(err);
      newToast('ERROR', 'Error cargando backups', 4);
      setDataSource([]);
    } finally {
      gridRef.current?.instance?.endCustomLoading();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleCreateBackup = useCallback(async () => {
    try {
      setIsCreating(true);
      await Create();      
      await fetchData();
    } catch (err) {
      console.error('Error creating backup', err);
      newToast('ERROR', 'Error creando backup', 4);
    } finally {
      setIsCreating(false);
    }
  }, [Create, fetchData]);

  return (
    <div className={'view crm-contact-list backups'}>
      <div className={'view-wrapper view-wrapper-contact-list'}>
        <div className='backup-actions'>
          <Button
            id='CreateBackupBtn'
            icon='save'
            text='Crear Nuevo Backup'
            type='default'
            stylingMode='contained'
            onClick={handleCreateBackup}
            disabled={isCreating}
          />
          <Tooltip target={'#CreateBackupBtn'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
            Crear una copia de seguridad de la base de datos
          </Tooltip>
        </div>

        <DataGrid 
          className='grid' 
          dataSource={dataSource} 
          ref={gridRef} 
          keyExpr='Bk_Id' 
          height='100%' 
          width={'100%'} 
          repaintChangesOnly={false} 
          highlightChanges={false} 
          hoverStateEnabled={true} 
          rowAlternationEnabled={true} 
          showColumnLines={true}
        >
          <LoadPanel enabled={true} />
          <SearchPanel visible placeholder='Buscar' />
          <Paging enabled={true} defaultPageSize={20} />
          <Pager 
            visible={true} 
            allowedPageSizes={[20, 50, 100, 'all']} 
            displayMode='full' 
            showPageSizeSelector={true} 
            showInfo={true} 
            showNavigationButtons={true} 
          />
          <Toolbar>
            <Item location='before'>
              <div className='grid-header'>Backups de Base de Datos</div>
            </Item>
            <Item name='searchPanel' />
          </Toolbar>

          <Column dataField='Bk_Id' caption='ID' alignment='center' width={90} />
          <Column dataField='Bk_Nombre' caption='NOMBRE' alignment='left' />
          <Column dataField='Bk_Fecha' caption='FECHA' alignment='center' dataType='datetime' width={200} />
          <Column dataField='Bk_Estado' caption='ESTADO' alignment='center' width={120} />
        </DataGrid>
      </div>
    </div>
  );
};
